/* eslint-disable camelcase */
export default function Technician({
  employee_id,
  entity_id,
  entity_name,
  entity_nav_full_id,
  first_name,
  full_name,
  position,
  id,
  last_name,
  mobile_user,
  phone,
  user_gid,
  scheduled,
  phone_type,
}) {
  this.employee_id = employee_id;
  this.entity_id = entity_id;
  this.entity_name = entity_name;
  this.entity_nav_full_id = entity_nav_full_id;
  this.first_name = first_name;
  this.full_name = full_name;
  this.position = position;
  this.id = id;
  this.last_name = last_name;
  this.mobile_user = mobile_user;
  this.phone = phone;
  this.user_gid = user_gid;
  this.scheduled = scheduled;
  this.phone_type = phone_type;
}
